import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromOauth from './reducers/oauth.reducer';
import { EffectsModule } from '@ngrx/effects';
import { OauthEffects } from './effects/oauth.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    EffectsModule.forFeature([ OauthEffects ]),
    StoreModule.forFeature('Oauth', fromOauth.reducer),
    StoreModule.forFeature('OauthLogin', fromOauth.OauthLoginreducer),
    StoreModule.forFeature('AccountOauthSWParam', fromOauth.AccountOauthSWParamreducer)
  ]
})
export class OauthModule { }
